import styled from 'styled-components'

export const Flag = styled.img`
    width: 25px;
    height: 25px;
    margin-right: 10px;
`;